"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function RefreshGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M3.16 10.96a.598.598 0 01-.542-.34A6.047 6.047 0 012 7.944a6.19 6.19 0 016.21-6.155c.349 0 .696.028 1.04.084a.61.61 0 11-.197 1.204 5.345 5.345 0 00-.842-.068 4.987 4.987 0 00-5.007 4.935c-.001.745.168 1.48.493 2.15a.593.593 0 01-.277.803.558.558 0 01-.26.064z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.986 2.15L10.008.188a.642.642 0 00-.706-.136.634.634 0 00-.401.597v3.92a.642.642 0 00.401.598.634.634 0 00.706-.136l1.978-1.962a.643.643 0 00.205-.462.633.633 0 00-.205-.457zM8.147 14.21c-.348 0-.696-.028-1.04-.084a.61.61 0 01.197-1.204c.278.047.56.07.843.069a4.987 4.987 0 005.007-4.935 4.895 4.895 0 00-.498-2.159.602.602 0 011.08-.525 6.02 6.02 0 01.621 2.684 6.191 6.191 0 01-6.21 6.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M7.055 10.832a.65.65 0 00-.706.137L4.371 12.93a.64.64 0 00-.204.461.634.634 0 00.192.458l1.978 1.962a.642.642 0 00.912-.003.654.654 0 00.191-.459v-3.92a.642.642 0 00-.385-.598z"
  }));
}

RefreshGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
RefreshGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = RefreshGreyOutline;
exports["default"] = _default;